import { Delete, Edit, Info } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import MyTable from '../../../../../components/MyTable';
import { AuthStore } from '../../../../../store/UserStore';
import { base_url } from '../../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../../utils/MyEncryption';

const Adendum = (props) => {
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const logOut = AuthStore((state) => state.logOut)
    const [deleting, setDeleting] = useState("");
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);

    useEffect(() => {
        console.log(props);
        if (props.noKontrak !== "") {
            requestData(props.noKontrak);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleting]);

    const requestData = (params) => {
        setTableLoading(true)
        console.log(params);
        axios.get(
            base_url + '/bnd/kontrak/adendum/' + params,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                console.log(response);
                const data = response.data;
                setTableData(data)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setTableLoading(false)
            })
    }

    const columns = [
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            filterable: false,
            hideable: false,
            // type: "number",
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            minWidth: 150,
            renderCell: (params) => {

                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Hapus Data">
                            <IconButton aria-label="confirm" color='error' onClick={() => handleDelete(params.row.no_adendum)}>
                                <Delete />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Lihat Data">
                            <IconButton aria-label="confirm" color='success' component={Link} to="/bnd/kontrak/adendum-detail" state={{adendum: params.row, kontrak: props.kontrak}}>
                                <Info />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <IconButton
                                aria-label="edit"
                                color="info"
                                component={Link}
                                to="/bnd/kontrak/adendum-edit"
                                state={{adendum: params.row, no_kontrak: null}}>
                                <Edit />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            },
        },
        {
            field: 'no_adendum',
            headerName: 'Nomor Adendum',
            minWidth: 230
        },
        {
            field: 'tgl_adendum',
            headerName: 'Tanggal Adendum',
            minWidth: 230
        },
        {
            field: 'jumlah_kontrak',
            headerName: 'Jumlah Kontrak',
            minWidth: 230,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.jumlah_kontrak);
            }
        },
        {
            field: 'tgl_mulai',
            headerName: 'Waktu Pengerjaan',
            renderCell: (params) => {
                return (
                    params.row.tgl_mulai + " s/d " + params.row.tgl_selesai
                )
            },
            minWidth: 230
        },
    ];
    
    const handleDelete = (params) => {
        console.log(params);
        setDeleting(params);
        const frmData = {
            _method: 'DELETE',
            no_adendum: params
        }

        Swal.fire({
            title: 'Hapus Data?',
            text: "Operasi tidak dapat Dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal',
            preConfirm: () => {
                return axios.post(
                    base_url + '/bnd/adendum/delete',
                    frmData,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        requestData(props.noKontrak);
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    return (
        <MyTable
            rows={tableData}
            columns={columns}
            row_id={(row) => row.no_adendum}
            isLoading={tableLoading}
        />
    )
}

export default Adendum